// removed by extract-text-webpack-plugin
module.exports = {"container":"HeaderedContent-container","logoContainer":"HeaderedContent-logoContainer","logo":"HeaderedContent-logo","supportId":"HeaderedContent-supportId","headerButton":"HeaderedContent-headerButton","icon":"HeaderedContent-icon","footerText":"HeaderedContent-footerText"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderedContent.scss
// module id = 756
// module chunks = 0